import { render, staticRenderFns } from "./GroupEdit.vue?vue&type=template&id=0f4c2508"
import script from "./GroupEdit.vue?vue&type=script&lang=js"
export * from "./GroupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f4c2508')) {
      api.createRecord('0f4c2508', component.options)
    } else {
      api.reload('0f4c2508', component.options)
    }
    module.hot.accept("./GroupEdit.vue?vue&type=template&id=0f4c2508", function () {
      api.rerender('0f4c2508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/groups/GroupEdit.vue"
export default component.exports